import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {shortenText} from '@specials/utils';

import {MaxStringLengthValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateMaxStringLength = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
  shouldLogError = true,
): string | null => {
  if (
    !ValidationUtils.isValidationRule<MaxStringLengthValidationRule>(rule, StatisticItemValidationType.MaxStringLength)
  ) {
    return null;
  }

  let statisticValue = statistic.value;
  const ruleValue = rule.value;

  if (ValidationUtils.isInvalidStringValue(statisticValue)) {
    // логируем некорректное строковое значение
    const error = FrontendError.createInvalidStringValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (statisticValue.length > ruleValue) {
    // логируем очень длинное значение
    const error = FrontendError.createLongStringValueError(statistic.metricDesc, statisticValue);

    if (shouldLogError) {
      logError(error);
    }
    // обрезаем строку
    statisticValue = shortenText(statisticValue, {postfix: '...', maxLength: ruleValue});
  }

  return statisticValue;
};
